import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=f674010a&"
import script from "./WelcomeView.vue?vue&type=script&lang=ts&"
export * from "./WelcomeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports